import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as subaward from '../subaward'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: subaward.RESOURCE.payload.dimension.partialId,
      partialId: subaward.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Entire expected period of performance for the work related to this subaward',
    isOptional: true,
    name: 'Estimated Period of Performance',
    partialId: PartialId.Standard.create('perf_period'),
    type: core.common.value.types.Intrinsic.DateRange,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
